// src/components/TournamentCard.js
import React from 'react';

export default function TournamentCard() {
  return (
    <section id="tournaments" className="my-8 font-mono">
      {/* Section title */}
      <div className="flex items-center mb-4">
            <h3 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-pink-400">
            Tournaments
            </h3>
            <div className="flex-grow h-px ml-4 bg-gradient-to-r from-violet-500/50 via-pink-500/50 to-transparent"></div>
            <div className="ml-2 px-2 py-1 bg-black bg-opacity-40 rounded text-xs text-pink-400 border border-pink-500/30">
              Upcoming
            </div>
          </div>

      {/* Gradient border wrapper */}
      <div className="animate-gradient-border mb-12 pt-4 mt-8 p-0.5 rounded-3xl mx-auto max-w-2xl">
        {/* Inner dark card */}
        <div className="bg-gray-900 rounded-3xl p-6 sm:p-8 lg:p-12 shadow-lg">
          <p className="text-base sm:text-lg text-gray-300 mb-6 text-center">
            Join weekly tournaments and boss battles for bonus rewards and exclusive NFT badges!
          </p>
          <div className="flex justify-center">
            <button className="
              bg-gradient-to-tr from-violet-500 via-pink-500 to-red-500
              hover:from-violet-600 hover:via-pink-600 hover:to-red-600
              text-white font-bold
              py-2 sm:py-3 px-6 sm:px-8
              rounded-full transition
              text-sm sm:text-base
              shadow-lg
            ">
              Coming Soon!
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
